type ProgramsCounterDataItem = {
  programsCount: number,
  fullPriceLabel: string,
  loanPriceLabel: string,
  counterLabel: string,
}

export function initProgramsCounter() {
  const container = document.querySelector<HTMLElement>(".js-programs-counter");

  if (!container) {
    console.error("Programs counter container not found");
    return
  }

  const programsDataAttribute = container.getAttribute("data-programs");
  if (!programsDataAttribute) {
    console.error("Programs data attribute not found");
    return;
  }

  let programsCountAttribute = container.getAttribute("data-programs-count");
  if (!programsDataAttribute) {
    console.warn("Programs count data attribute not found");
  }

  const programsData: ProgramsCounterDataItem[] = JSON.parse(programsDataAttribute);
  let currentCount = programsCountAttribute ? Number(programsCountAttribute) : 3;

  const minProgramsCount = Math.min(...programsData.map(dataItem => dataItem.programsCount));
  const maxProgramsCount = Math.max(...programsData.map(dataItem => dataItem.programsCount));

  const counterValueElement = container.querySelector<HTMLElement>(".js-programs-counter-value");
  const fullPriceElement = container.querySelector<HTMLElement>(".js-programs-counter-full-price");
  const loanPriceElement = container.querySelector<HTMLElement>(".js-programs-counter-loan-price");

  const buttonMinus = container.querySelector<HTMLButtonElement>(".js-programs-counter-minus-button");
  const buttonPlus = container.querySelector<HTMLButtonElement>(".js-programs-counter-plus-button");

  function updateDisplay(programsCount: number) {
    const item = programsData.find(dataItem => dataItem.programsCount === programsCount);
    if (!item) {
      return;
    }

    if (counterValueElement) {
      counterValueElement.textContent = item.counterLabel;
    }

    if (fullPriceElement) {
      fullPriceElement.textContent = item.fullPriceLabel;
    }

    if (loanPriceElement) {
      loanPriceElement.textContent = item.loanPriceLabel;
    }

    if (buttonMinus) {
      buttonMinus.disabled = programsCount === minProgramsCount;
    }

    if (buttonPlus) {
      buttonPlus.disabled = programsCount === maxProgramsCount;
    }
  }

  buttonMinus?.addEventListener("click", () => {
    if (minProgramsCount < currentCount) {
      currentCount--;
      updateDisplay(currentCount);
    }
  });

  buttonPlus?.addEventListener("click", () => {
    if (currentCount < maxProgramsCount) {
      currentCount++;
      updateDisplay(currentCount);
    }
  });

  updateDisplay(currentCount);
}